import axios from "axios";

/**
 * Returns true is application is running as a WordPress plugin.
 */
const isRunningAsWpPlugin = () => {
    return process.env.NODE_ENV === 'production';
}

/**
 * Returns the language code for the API if URL path begins with fr or frc.
 */
function getApiLanguagePrefix() {
    const language = window.location.pathname.split("/")[1];

    if ('fr' === language) {
        return '/fr';
    } else {
        return '';
    }
}

/**
 * Returns the API's base URL with possible language prefix.
 */
function getApiBaseUrl() {
    const isWp = isRunningAsWpPlugin();
    const baseUrl = isWp ? window.deploy_env.API_PATH : process.env.REACT_APP_API_PATH;
    const urlParts = new URL(baseUrl);
    const maybeFrenchPrefix = getApiLanguagePrefix();
    const apiBaseUrl = `${urlParts.origin}${maybeFrenchPrefix}${urlParts.pathname}`;

    return apiBaseUrl;
}

let baseURL = getApiBaseUrl();
let deploy_env = window.deploy_env ? window.deploy_env : false;

const http = axios.create({
    baseURL: deploy_env && deploy_env.API_PATH ? deploy_env.API_PATH : baseURL
});

export default http;
